import { SetRenewalBikeActionType } from '../types/actions';
import { ReservationDetailsType } from 'pages/Resabike/types/resabike';

export const SET_RENEWAL_BIKE = 'SET_RENEWAL_BIKE';

export const setRenewalBike = (reservationDetails: ReservationDetailsType | null): SetRenewalBikeActionType => ({
  type: SET_RENEWAL_BIKE,
  payload: {
    reservationDetails,
  },
});
